import { render } from "./DocumentsCertificatesSection.vue?vue&type=template&id=4ae203b0"
import script from "./DocumentsCertificatesSection.vue?vue&type=script&lang=js"
export * from "./DocumentsCertificatesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__